// extracted by mini-css-extract-plugin
export default {"btnLogin":"ModalForgotPassword_btnLogin__YGqIK","divStep":"ModalForgotPassword_divStep__gaWSJ"};